
import firebase from "firebase/compat/app"
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCpghAXLJZnyFgpAlXgbh-G3RAE99YqSAY",
  authDomain: "kvis-alumni.firebaseapp.com",
  databaseURL: "https://kvis-alumni.firebaseio.com",
  projectId: "kvis-alumni",
  storageBucket: "kvis-alumni.appspot.com",
  messagingSenderId: "76434656946",
  appId: "1:76434656946:web:23b458a80d3f9794"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth;
export const firestore = firebase.firestore;
export const storage = firebase.storage;
